import { useLazyQuery } from '@apollo/client'
import { GET_MODULE } from './queries/getModules'
import { IGraphqlQueryProps } from '@dtos/Pagination'

interface IUseGetCourseProps extends IGraphqlQueryProps {
  moduleId?: string
  submodulesOffset?: number
  submodulesLimit?: number
  courseContentsOffset?: number
  courseContentsLimit?: number
}

export const useGetModules = ({
  id,
  moduleId,
  offset,
  limit,
  submodulesOffset = 0,
  submodulesLimit = 20,
  courseContentsOffset = 0,
  courseContentsLimit = 10,
}: IUseGetCourseProps) => {
  const [getModules, { data, loading, error, fetchMore, variables }] =
    useLazyQuery(GET_MODULE, {
      variables: {
        id,
        moduleId,
        offset,
        limit,
        submodulesOffset,
        submodulesLimit,
        courseContentsOffset,
        courseContentsLimit,
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
    })

  return { getModules, data, loading, error, fetchMore, variables }
}
